import {$qsAll, $qs} from '../../@shared/ts/dom';
import {type IResponse} from '../../@type/response';
import {addBanner, removeBanner} from './banner';
import {setInnerView} from './ui-utils';

declare const peachpay_admin: PeachPayAdminData;

/**
 * Handles navigation to/within PeachPay settings by navigation links with a hash value.
 * Overriding the default behavior allows us to keep the scroll position and update the UI with mostly CSS.
 */
function initHashedNavigationEvents() {
	// Target hashed navigation elements for same-page navigation.
	$qsAll('.pp-sub-nav-button, .nav-tab.current + .nav-sub-tabs .nav-sub-tab.hashed').forEach(($navElement: HTMLElement) => {
		$navElement.addEventListener('click', (event: Event) => {
			event.preventDefault();

			// Change URL hash without the page jump.
			const prevScrollY = document.body.scrollTop;
			window.location.href = $navElement.getAttribute('href') ?? '#';
			document.body.scrollTop = prevScrollY;

			// Update UI state.
			const hash = $navElement.getAttribute('href')?.split('#')[1] ?? '';
			setInnerView(hash);
		});
	});
}

// Setting UI for toggling PeachPay Express Checkout setting.
function initExpressCheckoutSetting() {
	const expressCheckoutSetting = $qs<HTMLInputElement>('#pp-checkout-enable');
	if (!expressCheckoutSetting) {
		return;
	}

	expressCheckoutSetting.addEventListener('change', async () => {
		// UI: loading state
		expressCheckoutSetting.disabled = true;

		removeBanner('#unsaved-changes-peachpay_message');
		addBanner('info', 'saving-changes', false, false);

		const formData = new FormData();

		formData.append('action', 'pp-checkout-enable');
		formData.append('security', peachpay_admin.nonces.enable_express_checkout);
		formData.append('setting_value', expressCheckoutSetting.checked ? 'true' : 'false');

		const response = await fetch(peachpay_admin.admin_ajax, {
			method: 'POST',
			body: formData,
		});

		const json = await response.json() as IResponse<boolean | string>;
		removeBanner('#saving-changes-peachpay_message');

		if (json.success) {
			addBanner('info', 'saved-changes', false, false);
			setTimeout(() => {
				removeBanner('#saved-changes-peachpay_message');
			}, 2000);
			expressCheckoutSetting.setAttribute('checked', 'checked');
		} else {
			addBanner('info', '', false, false);
			setTimeout(() => {
				removeBanner('#-peachpay_message');
			}, 2000);
		}

		expressCheckoutSetting.disabled = false;
	});
}

export {initHashedNavigationEvents, initExpressCheckoutSetting};
